import { Injectable } from '@angular/core';
import { embedDashboard, EmbeddedDashboard, EmbedDashboardParams } from '@superset-ui/embedded-sdk';

/** Thin wrapper over the Superset embedded SDK so specs can spy on it. */
@Injectable({ providedIn: 'root' })
export class SupersetEmbedder {
    embed(params: EmbedDashboardParams): Promise<EmbeddedDashboard> {
        return embedDashboard(params);
    }
}
